// action - account reducer
export const LOGIN = "@auth/LOGIN";
export const LOGOUT = "@auth/LOGOUT";
export const REGISTER = "@auth/REGISTER";
export const PROJECT_LIST = "PROJECT_LIST";
export const LOGIN_DATA = "LOGIN";
export const START_LOADER = "START_LOADER";
export const STOP_LOADER = "STOP_LOADER";
